import { useMutation } from '@tanstack/react-query';
import { DeleteCounterpartyLocationResponse } from '@spilca/accounting_ts/v1/auth_common/dtos_pb';
import { TGRPCPromiseReject } from '@monorepo/grpc';
import { REQUEST_TYPES, useGetRequest } from '@monorepo/requests';

const useDeleteLocation = () => {
  const mutator = useGetRequest(REQUEST_TYPES.DELETE_LOCATION);

  return useMutation<
    DeleteCounterpartyLocationResponse | null,
    TGRPCPromiseReject,
    number
  >({
    mutationFn: mutator,
    retry: false
  });
};

export default useDeleteLocation;
